export default __webpack_public_path__ + "static/media/pc1atr@2x.99ad445a.png";